import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconEnvelopSharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.005 5h-1v14h18V5h-17Zm15 3.5V7h-14v1.5l7 5.25 7-5.25Zm-14 2.5v6h14v-6l-6.4 4.8-.6.45-.6-.45-6.4-4.8Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconEnvelopSharpLine);
export default Memo;
